
(function documentTypeDefinition() {
    'use strict';
    angular.module('Entities')
        .service('adminDocumentTypeService', [
            'restUrlBuilder', '$injector', 'config', 'authExtend',
            function admindocumentTypeService(restUrlBuilder, $injector, config, authExtend) {

                this.getById = function getById(id, levelOfDetail) {
                    var params = { lod: levelOfDetail };

                    return restUrlBuilder.one('adminDocumentTypes', id)
                        .get({ params: params });

                };

                this.getNotInRole = function (roleId) {
                    var params = { NotInRole: roleId, applicationId: config.appId() };
                    return restUrlBuilder.all('adminDocumentTypes')
                        .get({ params: params });
                };

                this.get = function get(name, organizationalUnitId, metadataType, applicationId) {

                    var params = { Name: name, OrganizationalUnitId: organizationalUnitId, applicationId: applicationId, MetadataTypeFilter: metadataType };

                    if (!authExtend.isInRole('CONFIG ADMIN APPS')) {
                        params.applicationId = config.appId();
                    }

                    return restUrlBuilder.all('adminDocumentTypes')
                        .get({ params: params });

                };

                this.create = function documentTypeCreate(documentType) {
                    if (documentType === null)
                        throw "documentType no puede ser null";

                    if (!authExtend.isInRole('CONFIG ADMIN APPS')) {
                        documentType.applications = [];
                        documentType.applications.push({ applicationId: config.appId() });
                    }

                    return restUrlBuilder.all('adminDocumentTypes')
                        .post(documentType);
                };

                this.modify = function documentTypeModify(documentType) {
                    if (documentType === null)
                        throw "documentType no puede ser null";

                    return restUrlBuilder.all('adminDocumentTypes').put(documentType);
                };

                this.share = function documentTypeShare(documentType) {
                    if (documentType === null)
                        throw "documentType no puede ser null";

                    return restUrlBuilder.one('adminDocumentTypes/share', documentType.id).put();
                };

                this.notShare = function documentTypeNotShare(documentType) {
                    if (documentType === null)
                        throw "documentType no puede ser null";

                    return restUrlBuilder.one('adminDocumentTypes/notShare', documentType.id).put();
                };


                this.getRoleDocumentTypes = function getRoleDocumentTypes(roleId) {

                    return restUrlBuilder.one('roles', roleId)
                        .all('documentTypes')
                        .get();

                };

                this.setRoleDocumentTypes = function setRoleDocumentTypes(roleId, documentTypes) {

                    return restUrlBuilder.one('roles', roleId)
                        .all('documentTypes')
                        .put(documentTypes);

                };

                this.exportToJson = function exportToJson(documentTypeIds) {
                    return restUrlBuilder.all('adminDocumentTypes/exportToJson').put(documentTypeIds, { responseType: 'arraybuffer' });
                };

                this.exists = function exists(docTypeSystemNames) {
                    return restUrlBuilder.all('adminDocumentTypes/exists').post(docTypeSystemNames);
                };

                this.import = function importDocumentType(documentTypes, version, organizationalUnitId) {

                    if (documentTypes === null || documentTypes.size <= 0) {
                        throw "documentTypes no puede ser null";
                    }

                    var $upload = $injector.get('Upload');
                    if ($upload === null)
                        throw "No se pudo instanciar $upload. Verifique que se cargó el script ng-file-upload";

                    return $upload.upload({
                        url: config.apiUrl('/AdminDocumentTypes/Import'),
                        method: 'POST',
                        fields: {
                            applicationId: config.appId(),
                            organizationalUnitId: organizationalUnitId,
                            version: version
                        },
                        file: documentTypes,
                        fileFormDataName: 'imageFile'
                    });
                };

                this.touchDocuments = function touchDocuments(doctype) {
                    var params = { typeId: doctype };

                    return restUrlBuilder.all('documentsBulk/Touch').put(params);
                };
            }
        ]);
})();